import { StaffRemindersHistory } from '../../lib/types/models/staff/staff-reminder'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getAffectedStaffReminders(id: number) {
  return restApiClient
    .url(constructApiUrl(API.affectedStaffs.getReminders.url, { id }))
    .get<StaffRemindersHistory>()
}
